<template>
    <div>
        <div v-show="!mostrarMetas">
            <b-card no-body>
                <b-card-header>
                    <span class="h5">
                        Ações
                    </span>
                </b-card-header>
                <b-card-body>
                    <div>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <app-tabela
                            :itens="acoes"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false">
                        <template slot="botoes">
                            <b-button-group class="float-right">
                                <btn-inserir-acao
                                    :pleito="pleito"
                                    class="mr-2"
                                    :dataServicos="dataServicos"
                                    @atualizarLista="atualizarLista()">
                                </btn-inserir-acao>
                            </b-button-group>
                        </template>
                        <template slot="acoes" slot-scope="data">
                                <btn-excluir-acao
                                    :pleito="pleito"
                                    class="text-danger float-left mr-1"
                                    :acao="data"
                                    :dataServicos="dataServicos"
                                    @atualizarLista="atualizarLista()">
                                </btn-excluir-acao>
                                <btn-mostrar-metas
                                    @atualizarMeta="atualizarMeta($event)"
                                    @receberAcao="acao = $event"
                                    :acao="data"
                                    :dataServicos="dataServicos"
                                ></btn-mostrar-metas>
                        </template>
                        <template slot="nomeAcao" slot-scope="data">
                                <p class="text-left m-0">
                                    {{ data.nomeAcao }}
                                </p>
                            </template>
                            <template slot="vigencia" slot-scope="data">
                                <p class="text-left m-0">
                                    {{ data.vigencia }}
                                </p>
                            </template>
                            <template slot="nomeUnidade" slot-scope="data">
                                <p class="text-left m-0">
                                    {{ data.nomeUnidade }}
                                </p>
                            </template>
                        </app-tabela>
                    </div>
                </b-card-body>
            </b-card>
        </div>
        <div v-if="mostrarMetas">
            <metas
                :pleito="pleito"
                :acao="acao"
                :acaoMetas="metas"
                :dataServicos="dataServicos"
                @atualizarAcao="atualizarLista()"
                @voltarAcao="voltarAcao()">
            </metas>
        </div>
    </div>
</template>
    
<script>
import BtnInserirAcao from './BtnInserirAcao'
import BtnExcluirAcao from './BtnExcluirAcao'
import BtnMostrarMetas from './BtnMostrarMetas.vue'
import Metas from './Metas.vue'

export default {
    components: {
        BtnInserirAcao,
        BtnExcluirAcao,
        BtnMostrarMetas,
        Metas
    },

    props: {
        dataServicos: {
            type: Object
        },
        pleito: {
            type: Object,
        },
        pleitoAcoes: {
            type: Array,
        }
    },

    data() {
        return {
            erros: [],
            acoes: [],
            metas: null,
            acao:null,
            itensPorPagina: 5,
            campos: [
                {
                    key: 'nomeAcao',
                    label: 'Nome da Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeUnidade',
                    label: 'Unidade',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vigencia',
                    label: 'Vigência',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],

        }
    },

    methods:{
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterAcoes(this.$route.params.pleitoId).then((response) => {
            if (response) {
                if (response.success) {
                    this.acoes = response.data
                } else {
                    this.erros = response.errors
                }
            }
            this.$store.dispatch('removeRequest')
            })
        },
        atualizarMeta(metas) {
            this.metas = metas
        },
        receberAcao(acao) {
            this.acao = acao
        },
        voltarAcao(){
            this.metas = null;
        }
    },
    computed: {
        mostrarMetas() {
            return this.metas != null
        },
    },
    mounted() {
        this.acoes = this.pleitoAcoes
    }
}
</script>
